import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import WhatsAppDiagnostic from './components/WhatsAppDiagnostic';
import WindowTypes from './components/WindowTypes';
import HardwareBrands from './components/HardwareBrands';
import WindowBrands from './components/WindowBrands';
import About from './components/About';
import ServiceArea from './components/ServiceArea';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import CTA from './components/CTA';
import Footer from './components/Footer';
import SEOContentZone from './components/SEOContentZone';
import SEOContentBottom from './components/SEOContentBottom';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <TrustSection />
      <WindowTypes />
      <About />
      <WindowBrands />
      <HardwareBrands />
      <SEOContentZone />
      <Testimonials />
      <SEOContentBottom />
      <ServiceArea />
      <Gallery />
      <FAQ />
      <CTA />
      <WhatsAppDiagnostic />
      <Contact />
      <Footer />
    </div>
  );
}
